import Head from "next/head";
import IxtalTablesPage from "../../../../src/tables/s16/IxtalTables.tsx";

export default function IxtalTablesRoute({ tables }) {
  return (
    <>
      <Head>
        <title>TFT Set 16 Ixtal Tables</title>
      </Head>
      <IxtalTablesPage tables={tables} />
    </>
  );
}

export async function getStaticProps() {
  const tablesResp = await fetch(
    `https://ap.tft.tools/static/s16/ixtal_loot.json`,
  );
  const tables = await tablesResp.json();

  return {
    props: {
      tables,
    },
    revalidate: 3600,
  };
}
